import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";  
import Swal from 'sweetalert2/dist/sweetalert2.js'; 

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  constructor(public user: UserService,public router: Router, private SpinnerService: NgxSpinnerService) { 
	var nu_first_name = localStorage.getItem('nu_first_name');
    if(nu_first_name !== null){
      this.router.navigate(['/subscriptions']);
    }
  }

  ngOnInit(): void {
	document.body.classList.add('bluebaground');
	
  }
  
  confirmEmail = '';
  validPassword = false;
  validPasswordMsg = '';
  emailError:string = '';
  passwordError:string = '';
  confirmPasswordError:string = '';
  signupSuccess='';
  

  	checkInput(input){
		if(input == 'email')
		this.emailError = '';
		if(input == 'password')
		this.passwordError = '';
    }

  signupUser(event){
	this.SpinnerService.show();  
  	event.preventDefault();
  	const target = event.target;
  	const email = target.querySelector("#email").value.trim();
  	const password = target.querySelector("#password").value.trim();
	const confirmPassword = target.querySelector("#cnfrm_password").value.trim();
	const first_name = target.querySelector("#fname").value.trim();
	const last_name = target.querySelector("#lname").value.trim();
	  	if(password != confirmPassword){
			this.SpinnerService.hide();
			this.confirmPasswordError = 'Please enter same password as above';
	  	}
	  	else{
			this.confirmPasswordError = '';
			this.user.signupRequest(email,password,first_name,last_name).subscribe(
				resp => {
					if(resp.status == 2){
						this.SpinnerService.hide();
						this.emailError = resp.validationErrors.email;
						this.passwordError = resp.validationErrors.password;
					}else{
						this.emailError = '';
						this.passwordError = '';
						//this.confirmEmail = resp.msg;
						Swal.fire(resp.msg_desc, resp.msg, 'success')
						//Swal.fire(resp.msg); 
						/* localStorage.setItem('nu_c_user_id', resp.id);
						localStorage.setItem('nu_email', resp.email);
						localStorage.setItem('nu_first_name', resp.first_name);
						localStorage.setItem('nu_last_name', resp.last_name); */
						this.router.navigate(['/login']);
					
					}
				}
			);
		}
  }

  ngOnDestroy(): void {
    document.body.classList.remove('bluebaground');
  }
  enterPassword(event){
	//console.log(event);
	var res;
	var str = event;
	if(event != ''){
		if (str.match( 
				/[0-9]/g) && str.match( 
				/[^a-zA-Z\d]/g) && str.length >= 8) {
			res = "TRUE"; 
			this.validPassword = true;
			this.validPasswordMsg = '';
		}
		else {
			this.validPasswordMsg = 'Password must contain minimum 8 characters, 1 number, 1 alphabet and 1 special character';
			res = "FALSE";
			this.validPassword = false;
		}
	}
	//console.log(res);
  }

}
